import { Link } from 'react-router-dom'
import { SITE } from '../data/site.js'

export default function Terms() {
  return (
    <main className="container page page-narrow">
      <nav className="breadcrumbs"><Link to="/">Home</Link> / <span>Terms & Conditions</span></nav>
      <header className="page-head">
        <h1>Terms & Conditions</h1>
        <p>Last updated: 8 August 2026</p>
      </header>

      <section className="prose policy">
        <p>
          These Terms and Conditions ("Terms") govern your use of this website and your purchase of
          products from {SITE.legalName} ({SITE.abn}) ("we", "us", "our"). By placing an order or using
          our website, you agree to these Terms.
        </p>

        <h2>1. About us</h2>
        <p>
          {SITE.legalName} ({SITE.abn}). Our warehouse and business address is {SITE.address}. We supply
          frameless and semi-frameless shower screens, glass panels and related hardware — supply only,
          with warehouse pickup or local delivery within 50 km of Ravenhall (Victoria).
        </p>

        <h2>2. Orders and acceptance</h2>
        <p>
          An order placed through our website constitutes an offer to purchase. We reserve the right to
          accept or decline any order at our discretion. Acceptance is confirmed when we verify your
          payment and confirm the order.
        </p>

        <h2>3. Pricing and GST</h2>
        <ul>
          <li>All prices are in Australian Dollars (AUD) and exclude GST</li>
          <li>GST (10%) is added at checkout and shown on your tax invoice</li>
          <li>Delivery is a flat rate shown at checkout; warehouse pickup is free</li>
          <li>
            Prices may change at any time; the price applicable to your order is the price displayed
            when you place it. If a pricing error occurs, we will contact you to confirm whether you
            wish to proceed at the correct price.
          </li>
        </ul>

        <h2>4. Payment</h2>
        <p>
          We accept credit/debit card (Visa, Mastercard, American Express) processed securely by Stripe,
          or direct bank transfer using the account details and unique payment reference shown after
          checkout. Card payments are confirmed instantly; we do not see or store your card details.
          Payment is required in full before your order is processed. Bank-transfer orders are held for
          3 business days; unpaid orders may then be cancelled. For custom or made-to-order glass, full
          payment is required before production begins.
        </p>

        <h2>5. Custom and made-to-order products</h2>
        <ul>
          <li>Full payment is required at the time of ordering</li>
          <li>We confirm your measurements with you before production begins</li>
          <li>All glass is inspected before dispatch; sizes carry a tolerance of up to 3mm</li>
          <li>Custom products cannot be returned or exchanged unless they arrive damaged or are manufactured incorrectly</li>
        </ul>

        <h2>6. Pickup and delivery</h2>
        <p>
          Warehouse pickup from {SITE.address} is free — we'll contact you when your order is ready.
          Delivery is available within 50 km of our Ravenhall warehouse (Victoria only) at the flat rate
          shown at checkout; if your address is outside the zone we will contact you before processing.
          Full details are in our <Link to="/shipping">Shipping & Returns</Link> policy. Risk in the
          goods passes to you on delivery or pickup. Please inspect your order on arrival and report
          transit damage within 48 hours with photos.
        </p>

        <h2>7. Returns and warranty</h2>
        <ul>
          <li>Hardware is covered by a 2-year warranty against manufacturing defects</li>
          <li>Eligible stocked items may be returned within 30 days, unused and in original packaging</li>
          <li>Custom-made glass cannot be returned unless faulty or incorrectly manufactured</li>
          <li>
            Nothing in these Terms excludes your rights under the Australian Consumer Law, including
            consumer guarantees that goods are of acceptable quality and fit for purpose
          </li>
        </ul>

        <h2>8. Product information</h2>
        <p>
          We take care to describe products accurately. Product photos are indicative; finishes may vary
          slightly between batches and screens. All glass complies with AS/NZS 2208. If you are unsure
          which configuration suits your space, <Link to="/contact">contact us</Link> before ordering.
        </p>

        <h2>9. Liability</h2>
        <p>
          To the extent permitted by law, our liability for any claim arising from an order is limited
          to replacement of the goods or refund of the amount paid. We supply products only and are not
          responsible for installation or for damage arising from incorrect installation by others.
        </p>

        <h2>10. Contact</h2>
        <p>
          Questions about these Terms: <a href={`mailto:${SITE.email}`}>{SITE.email}</a> ·{' '}
          <a href={SITE.phoneHref}>{SITE.phone}</a>
        </p>

        <p className="muted">{SITE.legalName} · {SITE.abn} · {SITE.address}</p>
      </section>
    </main>
  )
}
